<template lang="html">
    <h3 v-if="textType == 'title'" :class="['text', textType, textAlign]">
        <slot />
    </h3>
    <p v-if="textType == 'autor'" :class="['text', textType, textAlign]">
        <slot />
    </p>
    <p v-if="textType == 'place'" :class="['text', textType, textAlign]">
        <slot />
    </p>
    <p v-if="textType == 'time'" :class="['text', textType, textAlign]">
        <slot />
    </p>
    <h5 v-if="textType == 'subtitle'" :class="['text', textType, textAlign]">
        <slot />
    </h5>
    <p v-if="textType == 'normalRegular'" :class="['text', textType, textAlign]">
        <slot />
    </p>
    <p v-if="textType == 'normalMedium'" :class="['text', textType, textAlign]">
        <slot />
    </p>
    <p v-if="textType == 'normalMediumBlue'" :class="['text', textType, textAlign]">
        <slot />
    </p>
    <p v-if="textType == 'autorTime'" :class="['text', textType, textAlign]">
        <slot />
    </p>
    <p v-if="textType == 'normalBold'" :class="['text', textType, textAlign]">
        <slot />
    </p>
</template>
<script>
export default {
    props: {
        textType: {
            type: String,
            default: "normalRegular"
        },
        textAlign: {
            type: String,
            default: "left"
        }
    }
}
</script>
<style lang="css" scoped>
.text {
    /* display: inline-flex; */
    font-family: "Roboto";
    font-style: normal;
    margin-bottom: 0;
}
.text.left {
    text-align: left;
}
.text.center {
    text-align: center;
}
.text.right {
    text-align: right;
}
.text.title {
    font-family: 'Work Sans', sans-serif;
    font-weight: 500;
    font-size: 45px;
    line-height: 53px;
    color: #33647e;
}
.text.autor {
    font-family: 'Work Sans', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    text-transform: uppercase;
    color: #33647e;
}
.text.place {
    font-family: 'Work Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    color: #999696;
}
.text.time {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: #8eb1c1;
}
.text.subtitle {
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    color: #013652;
}
.text.normalRegular {
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #696f72;
}
.text.normalMedium {
    font-weight: 500;
    font-size: 15px;
    line-height: 25px;
    color: #696f72;
}
.text.normalMediumBlue {
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
    color: #33647e;
}
.text.autorTime {
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-transform: uppercase;
    color: #636262;
}
.text.normalBold {
    font-weight: 700;
    font-size: 15px;
    line-height: 19px;
    color: #696f72;
}
</style>